module.exports = __webpack_public_path__ + "img/virtuous-vacations.e432ebc4.png";